import { createApp } from 'vue';
// Import heroicons
import { AdjustmentsVerticalIcon } from '@heroicons/vue/24/solid';
import { ArrowPathIcon } from '@heroicons/vue/24/solid';
import { ArrowRightOnRectangleIcon } from '@heroicons/vue/24/solid';
import { ArrowRightCircleIcon } from '@heroicons/vue/24/solid';
import { ArrowUpRightIcon } from '@heroicons/vue/24/solid';
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/solid';
import { ArrowTrendingUpIcon } from '@heroicons/vue/24/solid';
import { BeakerIcon } from '@heroicons/vue/24/solid';
import { BookmarkIcon } from '@heroicons/vue/24/outline';
import { BookmarkSquareIcon } from '@heroicons/vue/24/outline';
import { CalendarIcon } from '@heroicons/vue/24/solid';
import { CameraIcon } from '@heroicons/vue/24/solid';
import { ChartBarIcon } from '@heroicons/vue/24/solid';
import { ChatBubbleOvalLeftIcon } from '@heroicons/vue/24/outline';
import { CheckIcon } from '@heroicons/vue/24/solid';
import { CheckBadgeIcon } from '@heroicons/vue/24/solid';
import { CheckCircleIcon } from '@heroicons/vue/24/solid';
import { ChevronUpIcon } from '@heroicons/vue/24/solid';
import { ChevronDownIcon } from '@heroicons/vue/24/solid';
import { ChevronRightIcon } from '@heroicons/vue/24/solid';
import { ChevronUpDownIcon } from '@heroicons/vue/24/solid';
import { ClockIcon } from '@heroicons/vue/24/solid';
import { ClipboardIcon } from '@heroicons/vue/24/outline';
import { CogIcon } from '@heroicons/vue/24/solid';
import { CreditCardIcon } from '@heroicons/vue/24/outline';
import { DocumentDuplicateIcon } from '@heroicons/vue/24/solid';
import { EnvelopeIcon } from '@heroicons/vue/24/solid';
import { EyeIcon } from '@heroicons/vue/24/solid';
import { FireIcon } from '@heroicons/vue/24/solid';
import { FlagIcon } from '@heroicons/vue/24/solid';
import { FolderIcon } from '@heroicons/vue/24/solid';
import { FolderOpenIcon } from '@heroicons/vue/24/solid';
import { InformationCircleIcon } from '@heroicons/vue/24/outline';
import { LightBulbIcon } from '@heroicons/vue/24/solid';
import { KeyIcon } from '@heroicons/vue/24/solid';
import { XMarkIcon } from '@heroicons/vue/24/solid';
import { MicrophoneIcon } from '@heroicons/vue/24/solid';
import { MinusIcon } from '@heroicons/vue/24/solid';
import { PencilIcon } from '@heroicons/vue/24/solid';
import { PencilSquareIcon } from '@heroicons/vue/24/solid';
import { PlusIcon } from '@heroicons/vue/24/solid';
import { PlusCircleIcon } from '@heroicons/vue/24/outline';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline';
import { RectangleStackIcon as RectangleStackOutlineIcon } from '@heroicons/vue/24/outline';
import { RectangleStackIcon as RectangleStackSolidIcon } from '@heroicons/vue/24/solid';
import { Square2StackIcon } from '@heroicons/vue/24/outline';
import { SquaresPlusIcon as SquaresPlusMiniIcon } from '@heroicons/vue/20/solid';
import { SquaresPlusIcon as SquaresPlusSolidIcon } from '@heroicons/vue/24/solid';
import { StarIcon } from '@heroicons/vue/24/solid';
import { TrashIcon } from '@heroicons/vue/24/solid';
import { UserIcon } from '@heroicons/vue/24/solid';
import { UserCircleIcon } from '@heroicons/vue/24/outline';
import { UsersIcon } from '@heroicons/vue/24/solid';
import { VideoCameraIcon } from '@heroicons/vue/24/solid';
// Import headless UI
import { Dialog } from '@headlessui/vue';
import { DialogPanel } from '@headlessui/vue';
import { DialogTitle } from '@headlessui/vue';
import { DialogDescription } from '@headlessui/vue';
import { Disclosure } from '@headlessui/vue';
import { DisclosureButton } from '@headlessui/vue';
import { DisclosurePanel } from '@headlessui/vue';
import { Listbox } from '@headlessui/vue';
import { ListboxButton } from '@headlessui/vue';
import { ListboxOptions } from '@headlessui/vue';
import { ListboxOption } from '@headlessui/vue';
import { Menu } from '@headlessui/vue';
import { MenuButton } from '@headlessui/vue';
import { MenuItem } from '@headlessui/vue';
import { MenuItems } from '@headlessui/vue';
import { Popover } from '@headlessui/vue';
import { PopoverButton } from '@headlessui/vue';
import { PopoverGroup } from '@headlessui/vue';
import { PopoverPanel } from '@headlessui/vue';
import { Switch } from '@headlessui/vue';
import { SwitchGroup } from '@headlessui/vue';
import { SwitchLabel } from '@headlessui/vue';
import { TransitionChild } from '@headlessui/vue';
import { TransitionRoot } from '@headlessui/vue';
// Import custom components
import App from '@/App.vue';
import Footer from '@/partial/layout/Footer/Footer.vue';
import Helper from '@/partial/layout/Helper/Helper.vue';
import Navbar from '@/partial/layout/Navbar/Navbar.vue';
import NavbarDefault from '@/partial/layout/Navbar/NavbarDefault.vue';
import NavbarDesktop from '@/partial/layout/Navbar/NavbarDesktop.vue';
import NavbarMobile from '@/partial/layout/Navbar/NavbarMobile.vue';
import ContextDesktop from '@/partial/layout/Navbar/ContextDesktop.vue';
import MenuDesktop from '@/partial/layout/Navbar/MenuDesktop.vue';
import MenuMobile from '@/partial/layout/Navbar/MenuMobile.vue';
import ProfileDesktop from '@/partial/layout/Navbar/ProfileDesktop.vue';
import ProfileMobile from '@/partial/layout/Navbar/ProfileMobile.vue';
import ProfileIconSvg from '@/partial/layout/Navbar/ProfileIconSvg.vue';
import ToggleMobile from '@/partial/layout/Navbar/ToggleMobile.vue';
import NoticeTrial from '@/partial/layout/Navbar/NoticeTrial.vue';
import NoticeBasic from '@/partial/layout/Navbar/NoticeBasic.vue';
import SingleColumn from '@/partial/layout/Columns/SingleColumn.vue';
import DoubleColumn from '@/partial/layout/Columns/DoubleColumn.vue';
// Import panel components
import MenuPanel from '@/partial/panels/MenuPanel.vue';
import MenuPanelItem from '@/partial/panels/MenuPanelItem.vue';
import PlainPanel from '@/partial/panels/PlainPanel.vue';
import SalesPanel from '@/partial/panels/SalesPanel.vue';
import TabsPanel from '@/partial/panels/TabsPanel.vue';
import TabsPanelItem from '@/partial/panels/TabsPanelItem.vue';
import TogglePanel from '@/partial/panels/TogglePanel.vue';
import WidgetPanel from '@/partial/panels/WidgetPanel.vue';
// Import landing components
import LandingAudience from '@/partial/landing/LandingAudience.vue';
import LandingCallToAction from '@/partial/landing/LandingCallToAction.vue';
import LandingCompass from '@/partial/landing/LandingCompass.vue';
import LandingFeatures from '@/partial/landing/LandingFeatures.vue';
import LandingFooter from '@/partial/landing/LandingFooter.vue';
import LandingHeader from '@/partial/landing/LandingHeader.vue';
import LandingNavbar from '@/partial/landing/LandingNavbar.vue';
import LandingNewsletter from '@/partial/landing/LandingNewsletter.vue';
import LandingPricing from '@/partial/landing/LandingPricing.vue';
import LandingQuestions from '@/partial/landing/LandingQuestions.vue';
import LandingTestimonial from '@/partial/landing/LandingTestimonial.vue';
// Import action components
import CreatePodcastContract from '@/partial/actions/CreatePodcastContract.vue';
import DeletePodcastContract from '@/partial/actions/DeletePodcastContract.vue';
import SubscribePodcastPlan from '@/partial/actions/SubscribePodcastPlan.vue';
// Import block components
import ActionList from '@/partial/blocks/ActionList/ActionList.vue';
import ActionListItem from '@/partial/blocks/ActionList/ActionListItem.vue';
import ChangelogList from '@/partial/blocks/ChangelogList/ChangelogList.vue';
import ChangelogListItem from '@/partial/blocks/ChangelogList/ChangelogListItem.vue';
import ConversionTrigger from '@/partial/blocks/ConversionTrigger/ConversionTrigger.vue';
import MembershipList from '@/partial/blocks/MembershipList/MembershipList.vue';
import MembershipListItem from '@/partial/blocks/MembershipList/MembershipListItem.vue';
import DetailsList from '@/partial/blocks/DetailsList/DetailsList.vue';
import DetailsListItem from '@/partial/blocks/DetailsList/DetailsListItem.vue';
import DetailsListValue from '@/partial/blocks/DetailsList/DetailsListValue.vue';
import ExperimentCard from '@/partial/blocks/ExperimentCard/ExperimentCard.vue';
import ExperimentHeader from '@/partial/blocks/ExperimentHeader/ExperimentHeader.vue';
import InvitationList from '@/partial/blocks/InvitationList/InvitationList.vue';
import InvitationListItem from '@/partial/blocks/InvitationList/InvitationListItem.vue';
import PodcastPaywall from '@/partial/blocks/PodcastPaywall/PodcastPaywall.vue';
import PracticeCard from '@/partial/blocks/PracticeCard/PracticeCard.vue';
import PracticeCardMenu from '@/partial/blocks/PracticeCard/PracticeCardMenu.vue';
import PracticeCardMenuItem from '@/partial/blocks/PracticeCard/PracticeCardMenuItem.vue';
import PracticeHeader from '@/partial/blocks/PracticeHeader/PracticeHeader.vue';
import PracticeBullets from '@/partial/blocks/PracticeBullets/PracticeBullets.vue';
import PracticeBulletsItem from '@/partial/blocks/PracticeBullets/PracticeBulletsItem.vue';
import PricingPlanAccount from '@/partial/blocks/PricingPlans/PricingPlanAccount.vue';
import LifetimeAccess from '@/partial/blocks/PricingPlans/LifetimeAccess.vue';
import PricingPlanPodcast from '@/partial/blocks/PricingPlans/PricingPlanPodcast.vue';
import ConnectAccount from '@/partial/blocks/SteadyAccount/ConnectAccount.vue';
import PricingPlans from '@/partial/blocks/PricingPlans/PricingPlans.vue';
import PodcastHeader from '@/partial/blocks/PodcastHeader/PodcastHeader.vue';
import ProfileHeader from '@/partial/blocks/ProfileHeader/ProfileHeader.vue';
import RoadmapList from '@/partial/blocks/RoadmapList/RoadmapList.vue';
import RoadmapListItem from '@/partial/blocks/RoadmapList/RoadmapListItem.vue';
import StepWizard from '@/partial/blocks/StepWizard/StepWizard.vue';
import StepWizardItem from '@/partial/blocks/StepWizard/StepWizardItem.vue';
import GenericError from '@/partial/blocks/GenericError/GenericError.vue';
// Import input components
import SelectCategory from '@/partial/select/SelectCategory.vue';
import SelectMetric from '@/partial/select/SelectMetric.vue';
import SelectOrdering from '@/partial/select/SelectOrdering.vue';
import SelectPractice from '@/partial/select/SelectPractice.vue';
// Import filter components
import FilterPracticeStatus from '@/partial/filters/FilterPracticeStatus.vue';
import FilterPracticeOptions from '@/partial/filters/FilterPracticeOptions.vue';
import FilterPracticeCommitment from '@/partial/filters/FilterPracticeCommitment.vue';
import FilterPracticeExpansion from '@/partial/filters/FilterPracticeExpansion.vue';
import FilterPracticeInvestment from '@/partial/filters/FilterPracticeInvestment.vue';
import FilterPracticeKeywords from '@/partial/filters/FilterPracticeKeywords.vue';
import FilterPracticeRelevance from '@/partial/filters/FilterPracticeRelevance.vue';
// Import widget components
import ActionWidget from '@/partial/widgets/ActionWidget/ActionWidget.vue';
import ActionWidgetItem from '@/partial/widgets/ActionWidget/ActionWidgetItem.vue';
import ActivityWidget from '@/partial/widgets/ActivityWidget/ActivityWidget.vue';
import ActivityWidgetItem from '@/partial/widgets/ActivityWidget/ActivityWidgetItem.vue';
import AdviceWidget from '@/partial/widgets/AdviceWidget/AdviceWidget.vue';
import AppliedWidget from '@/partial/widgets/AppliedWidget/AppliedWidget.vue';
import AppliedWidgetItem from '@/partial/widgets/AppliedWidget/AppliedWidgetItem.vue';
import BookmarkWidget from '@/partial/widgets/BookmarkWidget/BookmarkWidget.vue';
import CoworkerWidget from '@/partial/widgets/CoworkerWidget/CoworkerWidget.vue';
import CoworkerWidgetItem from '@/partial/widgets/CoworkerWidget/CoworkerWidgetItem.vue';
import CommentWidget from '@/partial/widgets/CommentWidget/CommentWidget.vue';
import CommentWidgetItem from '@/partial/widgets/CommentWidget/CommentWidgetItem.vue';
import CommentWidgetPrompt from '@/partial/widgets/CommentWidget/CommentWidgetPrompt.vue';
import CompilationsWidget from '@/partial/widgets/CompilationsWidget/CompilationsWidget.vue';
import CompilationsWidgetItem from '@/partial/widgets/CompilationsWidget/CompilationsWidgetItem.vue';
import EpisodeWidget from '@/partial/widgets/EpisodeWidget/EpisodeWidget.vue';
import ExperimentWidget from '@/partial/widgets/ExperimentWidget/ExperimentWidget.vue';
import ExperimentWidgetItem from '@/partial/widgets/ExperimentWidget/ExperimentWidgetItem.vue';
import FeedbackWidget from '@/partial/widgets/FeedbackWidget/FeedbackWidget.vue';
import ObjectiveWidget from '@/partial/widgets/ObjectiveWidget/ObjectiveWidget.vue';
import OverviewWidget from '@/partial/widgets/OverviewWidget/OverviewWidget.vue';
import PresentWidget from '@/partial/widgets/PresentWidget/PresentWidget.vue';
import StrategyWidget from '@/partial/widgets/StrategyWidget/StrategyWidget.vue';
import EstimationWidget from '@/partial/widgets/EstimationWidget/EstimationWidget.vue';
import SimilaritiesWidget from '@/partial/widgets/SimilaritiesWidget/SimilaritiesWidget.vue';
import SimilaritiesWidgetItem from '@/partial/widgets/SimilaritiesWidget/SimilaritiesWidgetItem.vue';
import SetupWidget from '@/partial/widgets/SetupWidget/SetupWidget.vue';
import SetupWidgetItem from '@/partial/widgets/SetupWidget/SetupWidgetItem.vue';
import SubscribeWidget from '@/partial/widgets/SubscribeWidget/SubscribeWidget.vue';
import TrialWidget from '@/partial/widgets/TrialWidget/TrialWidget.vue';
// Import bullet components
import AppliedBullets from '@/partial/bullets/AppliedBullets.vue';
// Import menu components
import PracticeMenu from '@/partial/menus/PracticeMenu/PracticeMenu.vue';
import PracticeMenuItem from '@/partial/menus/PracticeMenu/PracticeMenuItem.vue';
// Import button components
import ActionButton from '@/partial/buttons/ActionButton.vue';
import CancelButton from '@/partial/buttons/CancelButton.vue';
import DeleteButton from '@/partial/buttons/DeleteButton.vue';
import RefreshButton from '@/partial/buttons/RefreshButton.vue';
import SalesButton from '@/partial/buttons/SalesButton.vue';
import SubmitButton from '@/partial/buttons/SubmitButton.vue';
import BackButton from '@/partial/buttons/BackButton.vue';
// Import input components
import FormField from '@/partial/input/FormField.vue';
import FormGroup from '@/partial/input/FormGroup.vue';
import FormButtons from '@/partial/input/FormButtons.vue';
import FormSection from '@/partial/input/FormSection.vue';
import FileUpload from '@/partial/input/FileUpload.vue';
import InputCheck from '@/partial/input/InputCheck.vue';
import InputDate from '@/partial/input/InputDate.vue';
import InputPassword from '@/partial/input/InputPassword.vue';
import InputText from '@/partial/input/InputText.vue';
import RadioGroup from '@/partial/input/RadioGroup.vue';
import InputSelect from '@/partial/input/InputSelect.vue';
import InputSwitch from '@/partial/input/InputSwitch.vue';
import Textarea from '@/partial/input/Textarea.vue';
// Import form components
import AccountForm from '@/partial/forms/AccountForm.vue';
import DeletionForm from '@/partial/forms/DeletionForm.vue';
import ExperimentForm from '@/partial/forms/ExperimentForm.vue';
import ImageForm from '@/partial/forms/ImageForm.vue';
import ImportForm from '@/partial/forms/ImportForm.vue';
import InvitationForm from '@/partial/forms/InvitationForm.vue';
import LoginForm from '@/partial/forms/LoginForm.vue';
import EvaluationForm from '@/partial/forms/EvaluationForm.vue';
import MilestonesForm from '@/partial/forms/MilestonesForm.vue';
import ObjectiveForm from '@/partial/forms/ObjectiveForm.vue';
import PasswordForm from '@/partial/forms/PasswordForm.vue';
import PodcastForm from '@/partial/forms/PodcastForm.vue';
import ProfileForm from '@/partial/forms/ProfileForm.vue';
import SetupForm from '@/partial/forms/SetupForm.vue';
import StageForm from '@/partial/forms/StageForm.vue';
import StrategyForm from '@/partial/forms/StrategyForm.vue';
import TraceableForm from '@/partial/forms/TraceableForm.vue';
// Register modals
import EvaluationModal from '@/partial/modals/EvaluationModal.vue';
// Add tooltip components
import ApplicationTooltip from '@/partial/tooltips/ApplicationTooltip.vue';
import CommitmentTooltip from '@/partial/tooltips/CommitmentTooltip.vue';
import ContinuationTooltip from '@/partial/tooltips/ContinuationTooltip.vue';
import CoverageTooltip from '@/partial/tooltips/CoverageTooltip.vue';
import EnduranceTooltip from '@/partial/tooltips/EnduranceTooltip.vue';
import EnjoymentTooltip from '@/partial/tooltips/EnjoymentTooltip.vue';
import ExpansionTooltip from '@/partial/tooltips/ExpansionTooltip.vue';
import ExpertiseTooltip from '@/partial/tooltips/ExpertiseTooltip.vue';
import ExperimentPracticeTooltip from '@/partial/tooltips/ExperimentPracticeTooltip.vue';
import ExperimentTitleTooltip from '@/partial/tooltips/ExperimentTitleTooltip.vue';
import ExperimentStartsAtTooltip from '@/partial/tooltips/ExperimentStartsAtTooltip.vue';
import ExperimentEndsAtTooltip from '@/partial/tooltips/ExperimentEndsAtTooltip.vue';
import ExperimentRemarksTooltip from '@/partial/tooltips/ExperimentRemarksTooltip.vue';
import InteractionTooltip from '@/partial/tooltips/InteractionTooltip.vue';
import InvestmentTooltip from '@/partial/tooltips/InvestmentTooltip.vue';
import MonetizationTooltip from '@/partial/tooltips/MonetizationTooltip.vue';
import RealizationTooltip from '@/partial/tooltips/RealizationTooltip.vue';
import RecurrenceTooltip from '@/partial/tooltips/RecurrenceTooltip.vue';
import ReferabilityTooltip from '@/partial/tooltips/ReferabilityTooltip.vue';
import RelevanceTooltip from '@/partial/tooltips/RelevanceTooltip.vue';
import ReputationTooltip from '@/partial/tooltips/ReputationTooltip.vue';
import SimilarityTooltip from '@/partial/tooltips/SimilarityTooltip.vue';
import ThroughputTooltip from '@/partial/tooltips/ThroughputTooltip.vue';
// Add support components
import Accessible from '@/partial/support/Accessible.vue';
import Authorize from '@/partial/support/Authorize.vue';
import Markdown from '@/partial/support/Markdown.vue';
import Onboarding from '@/partial/support/Onboarding.vue';
import Paginator from '@/partial/support/Paginator.vue';
import Potential from '@/partial/support/Potential.vue';
import Similarity from '@/partial/support/Similarity.vue';
import Spinner from '@/partial/support/Spinner.vue';
import Tooltip from '@/partial/support/Tooltip.vue';
import Progress from '@/partial/support/Progress.vue';
import Twemoji from '@/partial/support/Twemoji.vue';
import client from '@/client';
import router from '@/router';
import locale from '@/locale';
import store from '@/store';
var app = createApp(App);
app.use(router);
app.use(locale);
app.use(store);
// Initialize sentry
//sentry(app, router);
// Register heroicon components
app.component("AdjustmentsVerticalIcon", AdjustmentsVerticalIcon);
app.component("ArrowPathIcon", ArrowPathIcon);
app.component("ArrowRightOnRectangleIcon", ArrowRightOnRectangleIcon);
app.component("ArrowRightCircleIcon", ArrowRightCircleIcon);
app.component("ArrowUpRightIcon", ArrowUpRightIcon);
app.component("ArrowTopRightOnSquareIcon", ArrowTopRightOnSquareIcon);
app.component("ArrowTrendingUpIcon", ArrowTrendingUpIcon);
app.component("BeakerIcon", BeakerIcon);
app.component("BookmarkIcon", BookmarkIcon);
app.component("BookmarkSquareIcon", BookmarkSquareIcon);
app.component("CalendarIcon", CalendarIcon);
app.component("CameraIcon", CameraIcon);
app.component("ChartBarIcon", ChartBarIcon);
app.component("ChatBubbleOvalLeftIcon", ChatBubbleOvalLeftIcon);
app.component("CheckIcon", CheckIcon);
app.component("CheckBadgeIcon", CheckBadgeIcon);
app.component("CheckCircleIcon", CheckCircleIcon);
app.component("ChevronUpIcon", ChevronUpIcon);
app.component("ChevronDownIcon", ChevronDownIcon);
app.component("ChevronRightIcon", ChevronRightIcon);
app.component("ChevronUpDownIcon", ChevronUpDownIcon);
app.component("ClockIcon", ClockIcon);
app.component("ClipboardIcon", ClipboardIcon);
app.component("CogIcon", CogIcon);
app.component("CreditCardIcon", CreditCardIcon);
app.component("DocumentDuplicateIcon", DocumentDuplicateIcon);
app.component("EnvelopeIcon", EnvelopeIcon);
app.component("EyeIcon", EyeIcon);
app.component("FolderIcon", FolderIcon);
app.component("FireIcon", FireIcon);
app.component("FlagIcon", FlagIcon);
app.component("FolderOpenIcon", FolderOpenIcon);
app.component("InformationCircleIcon", InformationCircleIcon);
app.component("KeyIcon", KeyIcon);
app.component("LightBulbIcon", LightBulbIcon);
app.component("XMarkIcon", XMarkIcon);
app.component("MicrophoneIcon", MicrophoneIcon);
app.component("MinusIcon", MinusIcon);
app.component("PencilIcon", PencilIcon);
app.component("PencilSquareIcon", PencilSquareIcon);
app.component("PlusIcon", PlusIcon);
app.component("PlusCircleIcon", PlusCircleIcon);
app.component("QuestionMarkCircleIcon", QuestionMarkCircleIcon);
app.component("RectangleStackOutlineIcon", RectangleStackOutlineIcon);
app.component("RectangleStackSolidIcon", RectangleStackSolidIcon);
app.component("Square2StackIcon", Square2StackIcon);
app.component("Squares2x2MiniIcon", SquaresPlusMiniIcon);
app.component("Squares2x2SolidIcon", SquaresPlusSolidIcon);
app.component("SquaresPlusMiniIcon", SquaresPlusMiniIcon);
app.component("SquaresPlusSolidIcon", SquaresPlusSolidIcon);
app.component("StarIcon", StarIcon);
app.component("TrashIcon", TrashIcon);
app.component("UserIcon", UserIcon);
app.component("UserCircleIcon", UserCircleIcon);
app.component("UsersIcon", UsersIcon);
app.component("VideoCameraIcon", VideoCameraIcon);
// Register headlessui components
app.component("Dialog", Dialog);
app.component("DialogPanel", DialogPanel);
app.component("DialogTitle", DialogTitle);
app.component("DialogDescription", DialogDescription);
app.component("Disclosure", Disclosure);
app.component("DisclosureButton", DisclosureButton);
app.component("DisclosurePanel", DisclosurePanel);
app.component("Listbox", Listbox);
app.component("ListboxButton", ListboxButton);
app.component("ListboxOptions", ListboxOptions);
app.component("ListboxOption", ListboxOption);
app.component("Menu", Menu);
app.component("MenuButton", MenuButton);
app.component("MenuItem", MenuItem);
app.component("MenuItems", MenuItems);
app.component("Popover", Popover);
app.component("PopoverButton", PopoverButton);
app.component("PopoverGroup", PopoverGroup);
app.component("PopoverPanel", PopoverPanel);
app.component("Switch", Switch);
app.component("SwitchGroup", SwitchGroup);
app.component("SwitchLabel", SwitchLabel);
app.component("TransitionChild", TransitionChild);
app.component("TransitionRoot", TransitionRoot);
// Register layout components
app.component("Footer", Footer);
app.component("Helper", Helper);
app.component("Navbar", Navbar);
app.component("NavbarDefault", NavbarDefault);
app.component("NavbarDesktop", NavbarDesktop);
app.component("NavbarMobile", NavbarMobile);
app.component("ContextDesktop", ContextDesktop);
app.component("MenuDesktop", MenuDesktop);
app.component("MenuMobile", MenuMobile);
app.component("ProfileDesktop", ProfileDesktop);
app.component("ProfileMobile", ProfileMobile);
app.component("ProfileIconSvg", ProfileIconSvg);
app.component("NoticeBasic", NoticeBasic);
app.component("NoticeTrial", NoticeTrial);
app.component("ToggleMobile", ToggleMobile);
app.component("SingleColumn", SingleColumn);
app.component("DoubleColumn", DoubleColumn);
// Register panel components
app.component("MenuPanel", MenuPanel);
app.component("MenuPanelItem", MenuPanelItem);
app.component("PlainPanel", PlainPanel);
app.component("SalesPanel", SalesPanel);
app.component("TabsPanel", TabsPanel);
app.component("TabsPanelItem", TabsPanelItem);
app.component("TogglePanel", TogglePanel);
app.component("WidgetPanel", WidgetPanel);
// Register landing components
app.component("LandingAudience", LandingAudience);
app.component("LandingCallToAction", LandingCallToAction);
app.component("LandingCompass", LandingCompass);
app.component("LandingFeatures", LandingFeatures);
app.component("LandingFooter", LandingFooter);
app.component("LandingHeader", LandingHeader);
app.component("LandingNavbar", LandingNavbar);
app.component("LandingNewsletter", LandingNewsletter);
app.component("LandingPricing", LandingPricing);
app.component("LandingQuestions", LandingQuestions);
app.component("LandingTestimonial", LandingTestimonial);
// Register action components
app.component("CreatePodcastContract", CreatePodcastContract);
app.component("DeletePodcastContract", DeletePodcastContract);
app.component("SubscribePodcastPlan", SubscribePodcastPlan);
// Register block components
app.component("ActionList", ActionList);
app.component("ActionListItem", ActionListItem);
app.component("ChangelogList", ChangelogList);
app.component("ChangelogListItem", ChangelogListItem);
app.component("ConversionTrigger", ConversionTrigger);
app.component("MembershipList", MembershipList);
app.component("MembershipListItem", MembershipListItem);
app.component("DetailsList", DetailsList);
app.component("DetailsListItem", DetailsListItem);
app.component("DetailsListValue", DetailsListValue);
app.component("ExperimentCard", ExperimentCard);
app.component("ExperimentHeader", ExperimentHeader);
app.component("InvitationList", InvitationList);
app.component("InvitationListItem", InvitationListItem);
app.component("PodcastPaywall", PodcastPaywall);
app.component("PracticeCard", PracticeCard);
app.component("PracticeCardMenu", PracticeCardMenu);
app.component("PracticeCardMenuItem", PracticeCardMenuItem);
app.component("PricingPlans", PricingPlans);
app.component("ConnectAccount", ConnectAccount);
app.component("PricingPlanAccount", PricingPlanAccount);
app.component("LifetimeAccess", LifetimeAccess);
app.component("PricingPlanPodcast", PricingPlanPodcast);
app.component("PracticeHeader", PracticeHeader);
app.component("PracticeBullets", PracticeBullets);
app.component("PracticeBulletsItem", PracticeBulletsItem);
app.component("PodcastHeader", PodcastHeader);
app.component("ProfileHeader", ProfileHeader);
app.component("RoadmapList", RoadmapList);
app.component("RoadmapListItem", RoadmapListItem);
app.component("StepWizard", StepWizard);
app.component("StepWizardItem", StepWizardItem);
app.component("GenericError", GenericError);
// Register select components
app.component("SelectCategory", SelectCategory);
app.component("SelectMetric", SelectMetric);
app.component("SelectOrdering", SelectOrdering);
app.component("SelectPractice", SelectPractice);
// Register filter components
app.component("FilterPracticeStatus", FilterPracticeStatus);
app.component("FilterPracticeOptions", FilterPracticeOptions);
app.component("FilterPracticeCommitment", FilterPracticeCommitment);
app.component("FilterPracticeExpansion", FilterPracticeExpansion);
app.component("FilterPracticeInvestment", FilterPracticeInvestment);
app.component("FilterPracticeKeywords", FilterPracticeKeywords);
app.component("FilterPracticeRelevance", FilterPracticeRelevance);
// Register widget components
app.component("ActionWidget", ActionWidget);
app.component("ActionWidgetItem", ActionWidgetItem);
app.component("ActivityWidget", ActivityWidget);
app.component("ActivityWidgetItem", ActivityWidgetItem);
app.component("AdviceWidget", AdviceWidget);
app.component("AppliedWidget", AppliedWidget);
app.component("AppliedWidgetItem", AppliedWidgetItem);
app.component("BookmarkWidget", BookmarkWidget);
app.component("CommentWidget", CommentWidget);
app.component("CommentWidgetItem", CommentWidgetItem);
app.component("CommentWidgetPrompt", CommentWidgetPrompt);
app.component("CompilationsWidget", CompilationsWidget);
app.component("CompilationsWidgetItem", CompilationsWidgetItem);
app.component("CoworkerWidget", CoworkerWidget);
app.component("CoworkerWidgetItem", CoworkerWidgetItem);
app.component("EpisodeWidget", EpisodeWidget);
app.component("ExperimentWidget", ExperimentWidget);
app.component("ExperimentWidgetItem", ExperimentWidgetItem);
app.component("FeedbackWidget", FeedbackWidget);
app.component("ObjectiveWidget", ObjectiveWidget);
app.component("OverviewWidget", OverviewWidget);
app.component("PresentWidget", PresentWidget);
app.component("SetupWidget", SetupWidget);
app.component("SetupWidgetItem", SetupWidgetItem);
app.component("StrategyWidget", StrategyWidget);
app.component("EstimationWidget", EstimationWidget);
app.component("SimilaritiesWidget", SimilaritiesWidget);
app.component("SimilaritiesWidgetItem", SimilaritiesWidgetItem);
app.component("SubscribeWidget", SubscribeWidget);
app.component("TrialWidget", TrialWidget);
// Register bullet components
app.component("AppliedBullets", AppliedBullets);
// Register button components
app.component("ActionButton", ActionButton);
app.component("CancelButton", CancelButton);
app.component("DeleteButton", DeleteButton);
app.component("RefreshButton", RefreshButton);
app.component("SalesButton", SalesButton);
app.component("SubmitButton", SubmitButton);
app.component("BackButton", BackButton);
// Register input components
app.component("FormField", FormField);
app.component("FormGroup", FormGroup);
app.component("FormButtons", FormButtons);
app.component("FormSection", FormSection);
app.component("FileUpload", FileUpload);
app.component("InputCheck", InputCheck);
app.component("InputDate", InputDate);
app.component("InputPassword", InputPassword);
app.component("InputSelect", InputSelect);
app.component("InputSwitch", InputSwitch);
app.component("InputText", InputText);
app.component("RadioGroup", RadioGroup);
app.component("Textarea", Textarea);
// Register form components
app.component("AccountForm", AccountForm);
app.component("DeletionForm", DeletionForm);
app.component("ExperimentForm", ExperimentForm);
app.component("ImageForm", ImageForm);
app.component("ImportForm", ImportForm);
app.component("InvitationForm", InvitationForm);
app.component("LoginForm", LoginForm);
app.component("EvaluationForm", EvaluationForm);
app.component("MilestonesForm", MilestonesForm);
app.component("ObjectiveForm", ObjectiveForm);
app.component("PasswordForm", PasswordForm);
app.component("PodcastForm", PodcastForm);
app.component("ProfileForm", ProfileForm);
app.component("SetupForm", SetupForm);
app.component("StageForm", StageForm);
app.component("StrategyForm", StrategyForm);
app.component("TraceableForm", TraceableForm);
// Register modals
app.component("EvaluationModal", EvaluationModal);
// Register menus
app.component("PracticeMenu", PracticeMenu);
app.component("PracticeMenuItem", PracticeMenuItem);
// Register tooltip components
app.component("ApplicationTooltip", ApplicationTooltip);
app.component("CommitmentTooltip", CommitmentTooltip);
app.component("ContinuationTooltip", ContinuationTooltip);
app.component("CoverageTooltip", CoverageTooltip);
app.component("EnduranceTooltip", EnduranceTooltip);
app.component("EnjoymentTooltip", EnjoymentTooltip);
app.component("ExpansionTooltip", ExpansionTooltip);
app.component("ExpertiseTooltip", ExpertiseTooltip);
app.component("ExperimentPracticeTooltip", ExperimentPracticeTooltip);
app.component("ExperimentTitleTooltip", ExperimentTitleTooltip);
app.component("ExperimentStartsAtTooltip", ExperimentStartsAtTooltip);
app.component("ExperimentEndsAtTooltip", ExperimentEndsAtTooltip);
app.component("ExperimentRemarksTooltip", ExperimentRemarksTooltip);
app.component("InteractionTooltip", InteractionTooltip);
app.component("InvestmentTooltip", InvestmentTooltip);
app.component("MonetizationTooltip", MonetizationTooltip);
app.component("RealizationTooltip", RealizationTooltip);
app.component("RecurrenceTooltip", RecurrenceTooltip);
app.component("ReferabilityTooltip", ReferabilityTooltip);
app.component("RelevanceTooltip", RelevanceTooltip);
app.component("ReputationTooltip", ReputationTooltip);
app.component("SimilarityTooltip", SimilarityTooltip);
app.component("ThroughputTooltip", ThroughputTooltip);
// Register support components
app.component("Accessible", Accessible);
app.component("Authorize", Authorize);
app.component("Markdown", Markdown);
app.component("Onboarding", Onboarding);
app.component("Paginator", Paginator);
app.component("Potential", Potential);
app.component("Progress", Progress);
app.component("Similarity", Similarity);
app.component("Spinner", Spinner);
app.component("Tooltip", Tooltip);
app.component("Twemoji", Twemoji);
app.config.globalProperties.$http = client;
app.mount('#app');
